import React, { useMemo } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Container } from '../../components/layout/Container';
import { StorySection } from './StorySection';
import { VisionSection } from './VisionSection';
import { MissionSection } from './MissionSection';
import { StatsSection } from './StatsSection';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * About page component
 */
const About = () => {
  const { t } = useLanguage();

  return (
    <main className="min-h-screen bg-white">
      <PageHeader
        title={t('aboutPage.hero.title')}
        subtitle={t('aboutPage.hero.subtitle')}
      />

      {/* Story Section - First */}
      <StorySection story={t('aboutPage.story')} />



      {/* Vision Section */}
      <VisionSection vision={t('aboutPage.vision')} />

      {/* Stats Section */}
      <section className="py-12 bg-gray-50">
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {['experience', 'global', 'clients'].map((key, i) => (
              <div key={key} className="bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-lg transition-all duration-300">
                <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                  {t(`about.stats.${key}.value`)}
                </div>
                <div className="text-gray-600 font-medium">
                  {t(`about.stats.${key}.label`)}
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Mission Section - Last */}
      <MissionSection mission={t('aboutPage.mission')} />

    </main>
  );
};

export default About;
